import React, { Component } from 'react';
import moment from 'moment';
import { apis, requestApi2, fetchData } from '../lib/apis';
import { Tooltip, Modal, Button, message, Popover, Image } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getFileName, convertContentLink } from '../lib/helpers';

import WidgetAudioRecord from "./audio-record";
import ReactMarkdown from 'react-markdown';

const { confirm } = Modal; 

export default class Message extends Component {
  constructor(props) {
    super(props);
    this.myref = null;
    this.remove = false;
    this.state = {
      showConfirm: true,
      loadingButton: false,
      show: true,
      is_hidden: this.props.Message.is_hidden
    }
    this.mouseEnterDelay = 0.02;
    this.mouseLeaveDelay = 0.03;
    this.showViewImage = this.showViewImage.bind(this);
    this.reloadMes = this.reloadMes.bind(this);
  }
  componentWillMount() {

  }
  componentWillReceiveProps(nextProps) {
  }
  shouldComponentUpdate(nextProps, nextState) {
    if(JSON.stringify(nextProps.Message) !== JSON.stringify(this.props.Message)) return true;
    if (this.state.is_hidden !== nextState.is_hidden) return true;
    if (this.state.showConfirm !== nextState.showConfirm) return true;
    
    return false;
  }
  handleCommentReply = (e) => {
    e.preventDefault();
    if (this.props.handleCommentReply && this.props.Message) {
      this.props.handleCommentReply(this.props.Message);
    }
  }
  handleShowFormDirectNew = (e) => {
    e.preventDefault();
    if (this.props.handleShowFormDirectNew) {
      this.props.handleShowFormDirectNew(true, this.props.Message);
    }
  }
  actionRemove = async () => {
    try {
      var key = 'updatable';
      let data_remove = {};
      if (this.props.type == 'direct') {
        data_remove = {
          type: 'direct',
          item_id: this.props.Message.item_id
        }
      } else {
        if (this.props.type_cmt == 'reply') {
          data_remove = {
            type: 'reply',
            comment_id: this.props.Message.comment_id,
            parent_id: this.props.parentId
          }
        } else {
          data_remove = {
            type: 'comment',
            comment_id: this.props.Message.comment_id
          }
        }
      }

      let url = 'DeleteDirect.php';
      let formData = new FormData();
      let dataPostFanpage = {
        page_id: this.props.Message.user_owner_id
      };
      if (this.props.type == 'comment') {
        url = 'DeleteComment.php';
        formData.append('media_id', this.props.Message.media_id);
        formData.append('comment_id', this.props.Message.comment_id);
        formData.append('user_id', this.props.Message.user_owner_id);
        dataPostFanpage['comment_id'] = this.props.Message.comment_id;
        dataPostFanpage['type'] = 'comment';
      } else {
        formData.append('thread_id', this.props.Message.thread_id);
        formData.append('item_id', this.props.Message.item_id);
        formData.append('user_id', this.props.Message.user_owner_id);
        dataPostFanpage['item_id'] = this.props.Message.item_id;
      }
      if (this.props.channelSelected.acc_type == 5) url = 'api/v1/chat/fanpagefb/detele';
      this.setState({
        loadingButton: true
      })
      let res = await fetchData({
        url: url,
        method: 'post',
        data: this.props.channelSelected.acc_type != 5 ? formData : dataPostFanpage,
        type_api: this.props.channelSelected.acc_type == 5 ? 3 : 2
      })
      this.setState({
        showConfirm: true,
        loadingButton: false
      }, () => {
        message.success({ content: 'Thành công!', key, duration: 2 });
        if(this.props.getListMessage) this.props.getListMessage({ type: 'reset' });
      })
    } catch (err) {
      message.warning({ content: 'Đã có lỗi xảy ra vui lòng thử lại sau!', key, duration: 2 });
    } finally{
      this.setState({
        showConfirm: true,
        loadingButton: false
      })
    }
  }
  showDeleteConfirm = (e) => {
    if (!this.state.showConfirm) return;
    e.preventDefault();
    let _this = this;
    confirm({
      title: 'Bạn có chắc muốn xóa',
      icon: <ExclamationCircleOutlined />,
      content: '',
      okText: 'Tiếp tục',
      okType: 'danger',
      cancelText: 'Hủy',
      maskClosable: true,
      zIndex: 2000,
      onOk() {
        _this.setState({
          showConfirm: false
        }, () => {
          var key = 'updatable';
          message.loading({ content: 'Đang xử lý..', key });
          _this.actionRemove();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  showViewImage = (e, bol = true) => {
    e.preventDefault();
    if (!bol) return;
    if (this.props.showViewImage && e.target.src) {
      this.props.showViewImage(e.target.src);
    }
  }
  reloadMes = (e) => {
    e.preventDefault();
    let message = this.props.Message;
    if (this.props.reloadMes) {
      this.props.reloadMes(message);
    }
  }
  render() {
    if (!this.state.show) {
      return null;
    }

    // Render tin nhắn hệ thống (kết bạn)
    if (this.props.Message.item_type == 'event_friend_ack') {
       return (
         <li className="clearfix" style={{width: '100%', marginBottom: '15px', textAlign: 'center', listStyle: 'none'}}>
            <div style={{
               display: 'inline-flex',
               alignItems: 'center',
               backgroundColor: '#fff',
               padding: '8px 16px',
               borderRadius: '20px',
               boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
               maxWidth: '80%'
            }}>
               {this.props.Message.from && (
                   <img 
                      src={this.props.Message.from.avatar} 
                      onError={(e) => { e.target.src = require("../img/user.jpg") }}
                      style={{width: '24px', height: '24px', borderRadius: '50%', marginRight: '8px', objectFit: 'cover'}} 
                   />
               )}
               <span style={{fontSize: '13px', color: '#333', fontWeight: '500'}}>
                  {this.props.Message.content}
               </span>
            </div>
         </li>
       );
    }

    let messageContent = this.props.Message.content || "";
    // Regex highlight phone number
    const phoneRegex = /(0[3|5|7|8|9][0-9]{8})\b/g;
    if (messageContent && typeof messageContent === 'string') {
       messageContent = messageContent.replace(phoneRegex, "**$1**");
    }

    // Render Quote (tin nhắn reply)
    let quoteElement = null;
    if (this.props.Message.quote && this.props.Message.quote.msg) {
      quoteElement = (
        <div className="message-quote" style={{
          borderLeft: '3px solid #0068FF',
          paddingLeft: '10px',
          marginBottom: '8px',
          backgroundColor: 'rgba(0, 104, 255, 0.1)',
          borderRadius: '4px',
          padding: '8px 10px'
        }}>
          <div className="quote-sender" style={{ 
            fontWeight: 'bold', 
            color: '#0068FF',
            fontSize: '13px',
            marginBottom: '2px'
          }}>
            {this.props.Message.quote.fromD || 'Người gửi'}
          </div>
          <div className="quote-content" style={{ 
            color: '#666',
            fontSize: '12px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '200px'
          }}>
            {this.props.Message.quote.msg}
          </div>
        </div>
      );
    }

    var text_content = messageContent ? <ReactMarkdown source={messageContent} linkTarget="_blank" /> : null;
    var content = quoteElement ? [quoteElement] : [];
    if (text_content) content.push(text_content);

    if (this.props.Message.item_type == 'media' && this.props.Message.media || this.props.Message.item_type == 'reel_share' && this.props.Message.media) {
      content.push(<img key="img_media_direct" src={this.props.Message.media.image_versions2.candidates[0].url} className="inline-image image-clickable image-message" onClick={this.showViewImage} />);

    } else if (this.props.Message.item_type == 'like') {
      content = this.props.Message.reaction;
    } else if (this.props.Message.item_type == 'voice_media') {
      content = <audio controls="controls" name="media" className="audio"><source src={this.props.Message.voice_media.media.audio.audio_src} type="audio/mp4" /></audio>;
    } else if (this.props.Message.recordfile) {
      content.push(<WidgetAudioRecord file={this.props.Message.recordfile} />);
    } else if (this.props.Message.item_type == 'animated_media') {
      content = <img src={this.props.Message.images.images.fixed_height.url} className="inline-image image-clickable image-message" onClick={this.showViewImage} />;
    } else if (this.props.Message.item_type == 'media_share' && this.props.Message.media) {
      let media = this.props.Message.media;
      content = <div className="media-share">
        <a href={media.post_link} className="media-link" target="_blank"></a>
        <div className="media-owner">
          <div className="media-avatar">
            <img className="avatar"
              src={media.post_owner_avatar}
              onLoad={(e) => {
                e.target.className = "avatar avatar-ready";
              }}
              onError={(e) => {
                e.target.src = require("../img/user.jpg")
              }}
            />
          </div>
          <b>{media.post_owner_name}</b>
        </div>
        <div className="media">
          <img
            src={media.image_versions2.candidates[media.image_versions2.candidates.length - 1].url}
            className="inline-image image-clickable image-message"
            onLoad={(e) => {
              e.target.style = "opacity: 1";
            }}
            onError={(e) => {
              e.target.src = require("../img/no_images.png")
            }}
          />

          <div className="media-content">
            <b>{media.post_owner_name}</b> {media.caption_content.length < 80 ? media.caption_content : media.caption_content.slice(0, 80) + '..'}
          </div>
        </div>
      </div>;
    } else if (this.props.Message.item_type == 'link' && this.props.Message.link && this.props.Message.link.text) {
      let text = this.props.Message.link.text;
      let regex_links = text.match(/(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm);
      if (regex_links) {
        regex_links.forEach((item, i) => {
          text = text.replace(item, `<a href=${item} target="_blank">${item}</a>`)
        })
      }
      content = <p dangerouslySetInnerHTML={{ __html: text }}></p>
    } else if (this.props.Message.item_type == 'media_shopee') {
      content = <img src={this.props.Message.media.url} className="inline-image image-clickable image-message" onClick={this.showViewImage} />;
    } else if (this.props.Message.item_type == 'raven_media') {
      if (this.props.Message.visual_media && this.props.Message.visual_media.media && this.props.Message.visual_media.media.image_versions2 && this.props.Message.visual_media.media.image_versions2.candidates.length > 0) {
        content = <img src={this.props.Message.visual_media.media.image_versions2.candidates[0]['url']} className="inline-image image-clickable image-message" onClick={this.showViewImage} />;
      } else {
        return null
      }
    } else if (this.props.Message.item_type == 'contact_recommended') {
        const payload = (this.props.Message.attachments && this.props.Message.attachments[0]) ? this.props.Message.attachments[0].payload : {};
        content = (
            <div className="zalo-contact-card" style={{ width: '300px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', fontFamily: 'sans-serif', margin: '5px 0' }}>
                 <div style={{ background: '#0068FF', padding: '15px', display: 'flex', alignItems: 'center', color: '#fff', position: 'relative' }}>
                    <img src={payload.avatar} style={{ width: 48, height: 48, borderRadius: '50%', marginRight: 12, border: '1px solid rgba(255,255,255,0.3)', objectFit: 'cover' }} 
                        onError={(e) => { e.target.src = "https://page.shortcut-art.com/assets/img/profile.jpg" }} />
                    
                    <div style={{ flex: 1, zIndex: 1, minWidth: 0, paddingRight: 5 }}>
                        <div style={{ fontWeight: 'bold', fontSize: '15px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginBottom: 2 }}>{payload.name || "Danh thiếp"}</div>
                        <div style={{ fontSize: '13px', opacity: 0.9 }}>{payload.phone}</div>
                    </div>
                     
                     {payload.qrCode && <div style={{ background: '#fff', padding: '3px', borderRadius: '4px', marginLeft: 'auto' }}>
                         <img src={payload.qrCode} style={{ width: 55, height: 55, display: 'block' }} />
                     </div>}
                </div>

                 <div style={{ borderTop: '1px solid #eee', display: 'flex', background: '#fff' }}>
                     <div style={{ flex: 1, padding: '10px', textAlign: 'center', borderRight: '1px solid #f0f0f0', color: '#0068FF', fontWeight: 600, cursor: 'default', fontSize: '14px' }}>Kết bạn</div>
                     <div style={{ flex: 1, padding: '10px', textAlign: 'center', color: '#0068FF', fontWeight: 600, cursor: 'default', fontSize: '14px' }}>Nhắn tin</div>
                 </div>
            </div>
        )
    } else if (this.props.Message.item_type == 'photo_group') {
        // Render nhóm ảnh dạng grid giống Zalo
        const photos = this.props.Message.attachments || [];
        const count = photos.length;
        
        // Xác định layout dựa trên số ảnh
        let gridStyle = {};
        if (count === 2) {
            gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '2px', maxWidth: '300px' };
        } else if (count === 3) {
            gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gridTemplateRows: 'repeat(2, 1fr)', gap: '2px', maxWidth: '300px' };
        } else if (count >= 4) {
            gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '2px', maxWidth: '300px' };
        }
        
        content = (
            <div className="photo-group" style={gridStyle}>
                <Image.PreviewGroup>
                    {photos.slice(0, 4).map((photo, idx) => {
                        const url = photo.payload?.url || photo.url;
                        const isLast = idx === 3 && count > 4;
                        return (
                            <div key={idx} style={{ 
                                position: 'relative',
                                gridColumn: count === 3 && idx === 0 ? 'span 2' : 'auto',
                                aspectRatio: count === 3 && idx === 0 ? '2/1' : '1/1',
                                overflow: 'hidden'
                            }}>
                                <Image
                                    src={url}
                                    style={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                    }}
                                />
                                {isLast && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0, left: 0, right: 0, bottom: 0,
                                        background: 'rgba(0,0,0,0.5)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#fff',
                                        fontSize: '24px',
                                        fontWeight: 'bold',
                                        borderRadius: '4px'
                                    }}>
                                        +{count - 4}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </Image.PreviewGroup>
            </div>
        );
    } else if (this.props.Message.item_type == 'attachment') {
      // content = [];
      let attachments_html = [];

      this.props.Message.attachments.forEach((attachment, i) => {
        if (attachment.type == 'attachment' && attachment.payload && attachment.payload.image_data) {
          // content.push(<img key={'img_' + i} src={attachment.payload.image_data.preview_url} className="inline-image image-clickable image-message" onClick={this.showViewImage} />)
          attachments_html.push(<Image
            key={'img_' + i}
            src={attachment.payload.image_data.preview_url}
            className="inline-image image-clickable image-message"
          />)
        } else if (attachment.type.indexOf('image') > -1 && attachment.payload) {
          // content.push(<img key={'img_' + i}
          //   src={attachment.payload.url}
          //   className="inline-image image-clickable image-message"
          //   onClick={(e) => this.showViewImage(e, attachment.payload.sticker_id ? false : true)}
          // />)
          if (attachment.payload.sticker_id) {
            attachments_html.push(<img key={'img_' + i}
              src={attachment.payload.url}
              className="inline-image image-clickable image-message"
              style={{ maxWidth: "35px" }}
            />)
          } else {
            attachments_html.push(<Image
              key={'img_' + i}
              src={attachment.payload.url}
              className="inline-image image-clickable image-message"
            />)
          }
        } else if (attachment.media && attachment.media.image) {
          // content.push(<img key={'img_' + i} src={attachment.media.image.src} className="inline-image image-clickable image-message" onClick={this.showViewImage} />)
          attachments_html.push(<Image
            key={'img_' + i}
            src={attachment.media.image.src}
            className="inline-image image-clickable image-message"
          />)
        } else if ((attachment.type.indexOf('file') > -1 || attachment.type.indexOf('text') > -1) && attachment.payload) {
          const displayName = attachment.payload.name || getFileName(attachment.payload.url) || "Tệp đính kèm";
          const fileSize = attachment.payload.size ? `${(attachment.payload.size / 1024).toFixed(1)} KB` : '';
          attachments_html.push(
            <div key={'_attachment_file_' + i} className="file-attachment" style={{ 
              display: 'flex', 
              alignItems: 'center', 
              background: '#f5f5f5', 
              padding: '10px 12px', 
              borderRadius: '8px',
              gap: '10px',
              minWidth: '200px'
            }}>
              <i className="fal fa-file-alt" style={{ fontSize: '24px', color: '#0068FF' }}></i>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ 
                  fontWeight: 500, 
                  fontSize: '14px', 
                  color: '#333',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>{displayName}</div>
                {fileSize && <div style={{ fontSize: '12px', color: '#888' }}>{fileSize}</div>}
              </div>
              <Tooltip title="Tải xuống" mouseEnterDelay={this.mouseEnterDelay} mouseLeaveDelay={this.mouseLeaveDelay}>
                <a 
                  href={attachment.payload.url} 
                  download={displayName}
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ 
                    width: '32px', 
                    height: '32px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    background: '#0068FF',
                    borderRadius: '50%',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <i className="fal fa-download"></i>
                </a>
              </Tooltip>
            </div>
          )

        } else if (attachment.type.indexOf('video') > -1 && attachment.payload) {
          console.log('[Message] Rendering video attachment:', attachment.payload.url);
          attachments_html.push(
            <div id="video-mes" key={'video_' + i}>
              <video width="320" controls src={attachment.payload.url}>
                Your browser does not support the video tag.
              </video>
            </div>
          )
        } else if (attachment.type == 'sticker' && attachment.payload) {
          attachments_html.push(<img key={'img_' + i}
            src={attachment.payload.url}
            className="inline-image image-clickable image-message"
            style={{ maxWidth: "35px" }}
          />)
        } else if (attachment.payload && attachment.payload.video_data) {
          attachments_html.push(
            <div id="video-mes">
              <video width="320" controls>
                <source src={attachment.payload.video_data.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          )
        } else if (attachment.type == "fallback" && attachment.payload && attachment.payload.url && !this.props.Message.content) {
          attachments_html.push(<a class="link" target="_blank" href={attachment.payload.url}>{attachment.payload.title}</a>);
        }
      })

      content = attachments_html.length > 0 ? [<div className={`attachment ${attachments_html.length > 1 ? 'attachment-mutiple' : ''}`}>{attachments_html.length > 0 ? attachments_html : 'Tệp đính kèm'}</div>] : [];

      if (this.props.Message.content) {
        let isDuplicateUrl = false;
        if (this.props.Message.item_type === 'attachment' && this.props.Message.attachments) {
            isDuplicateUrl = this.props.Message.attachments.some(att => att.payload && att.payload.url === this.props.Message.content);
        }
        if (!isDuplicateUrl) {
           content.push(<ReactMarkdown key="markdown_content" source={this.props.Message.content} linkTarget="_blank" />)
        }
      }
    } else {
      if (!content || !Array.isArray(content) || content.length === 0) {
        content = <ReactMarkdown source={this.props.Message.content ? this.props.Message.content : " "} linkTarget="_blank" />
      }
    }

    let time_contact = moment(this.props.Message.timestamp);

    let time_send = `${time_contact.format('HH:mm:ss, DD/MM/YYYY')}`;
    // if (moment(this.props.Message.timestamp).startOf('day').unix() == moment(new Date()).startOf('day').unix()) {
    //   time_send = `${time_contact.format('HH:mm:ss, Do MMMM')}`;
    // } else {
    //   if (moment(time_contact).startOf('year').unix() == moment(new Date()).startOf('year').unix()) {
    //     time_send = `${time_contact.format('HH:mm:ss, Do MMMM')}`;
    //   } else {
    //     time_send = `${time_contact.format('MMMM YYYY')}`;
    //   }
    // }
    let reaction = null;
    if (this.props.Message.reaction && this.props.Message.reaction.reaction) {
      let action = this.props.Message.reaction.reaction;
      reaction = <span className={`reaction ${action.reaction}`}>{action.emoji}</span>
    }
    // console.log(this.props.Message);
    if (this.props.center) {
      if (this.props.Message.from && this.props.Message.to) {
        return (
          <li className={`right handle-sale ${this.props.Message.from._id == this.props.UserLogin._id ? 'handle-sale-1' : 'handle-sale-2'}`}>
            <div className="box-content">
              <div className="bubble">
                <div className="message-content">
                  <div className="d-flex align-items-center">
                    <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16.555 16.555" height="15" width="15"><g><g><path d="M6.409,7.421c0.034,0.207,0.114,0.337,0.193,0.42C6.789,9.084,7.83,10.24,8.781,10.24    c1.11,0,2.12-1.25,2.314-2.397c0.08-0.082,0.16-0.213,0.195-0.422c0.063-0.233,0.146-0.639,0.002-0.828    c-0.007-0.01-0.017-0.019-0.022-0.028c0.133-0.489,0.303-1.501-0.303-2.19C10.912,4.306,10.572,3.9,9.846,3.686L9.5,3.566    C8.928,3.39,8.568,3.35,8.553,3.349c-0.026-0.002-0.053,0-0.078,0.006C8.454,3.361,8.387,3.379,8.334,3.372    c-0.137-0.02-0.342,0.05-0.378,0.064C7.909,3.455,6.802,3.898,6.466,4.93C6.435,5.013,6.3,5.452,6.479,6.527    c-0.027,0.018-0.05,0.041-0.071,0.067C6.264,6.783,6.345,7.188,6.409,7.421z"></path><path d="M12.33,10.637c0,0-0.045-0.015-0.114-0.037c-0.478-0.224-0.929-0.367-0.929-0.367    c-0.098-0.033-0.182-0.067-0.26-0.103c-0.322-0.159-0.592-0.34-0.648-0.51c0,0,0.188,1.81-1.395,1.851l-0.219-0.01    c-1.433-0.127-1.528-1.845-1.528-1.845c-0.15,0.471-1.952,1.019-1.952,1.019c-0.536,0.204-0.762,0.514-0.762,0.514    c-0.792,1.176-0.885,3.789-0.885,3.789c0.01,0.598,0.268,0.66,0.268,0.66c1.821,0.812,4.679,0.955,4.679,0.955    c0.154,0.004,0.298-0.004,0.441-0.013l0.003,0.015c0,0,2.858-0.145,4.679-0.957c0,0,0.258-0.063,0.269-0.658    c0,0-0.094-2.614-0.886-3.789C13.092,11.148,12.865,10.841,12.33,10.637z"></path><path d="M10.316,9.698c0.021-0.026,0.041-0.052,0.063-0.078c-0.004-0.017-0.005-0.026-0.005-0.026    C10.356,9.632,10.336,9.661,10.316,9.698z"></path><path d="M7.246,9.614L7.241,9.595L7.237,9.616c0.001-0.004,0.004-0.009,0.006-0.011    C7.243,9.605,7.244,9.607,7.246,9.614z"></path><path d="M8.732,0C4.436,0,0.94,3.496,0.94,7.792c0,0.849,0.148,1.692,0.417,2.492l-0.702-0.157    c-0.277-0.065-0.55,0.111-0.612,0.388c-0.062,0.275,0.111,0.549,0.388,0.611l2.332,0.523c0.038,0.008,0.075,0.012,0.112,0.012    c0.234,0,0.446-0.162,0.5-0.399l0.499-2.221c0.062-0.276-0.112-0.55-0.387-0.612C3.208,8.368,2.937,8.54,2.875,8.816L2.706,9.571    C2.537,8.998,2.441,8.404,2.441,7.792c0-3.47,2.823-6.292,6.292-6.292s6.292,2.823,6.292,6.292c0,1.047-0.262,2.082-0.758,2.992    l1.318,0.717c0.614-1.131,0.939-2.412,0.939-3.709C16.524,3.496,13.028,0,8.732,0z"></path></g></g></svg>
                    <div style={{ marginLeft: "8px", color: "#fff" }}>
                      {this.props.Message.from._id == this.props.UserLogin._id ?
                        <span>Bạn đã chuyển khách hàng cho <a href="#" onClick={(e) => {
                          e.preventDefault();
                          this.props.handleDetailUser(this.props.Message.to)
                        }}>{this.props.Message.to.fullname}</a> chăm sóc</span> :
                        this.props.Message.to._id == this.props.UserLogin._id ?
                          <span><a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.props.handleDetailUser(this.props.Message.from)
                          }}>{this.props.Message.from.fullname}</a> đã chuyển khách hàng cho bạn chăm sóc</span> :
                          <span><a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.props.handleDetailUser(this.props.Message.from)
                          }}>{this.props.Message.from.fullname}</a> đã chuyển khách hàng cho <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.props.handleDetailUser(this.props.Message.to)
                          }}>{this.props.Message.to.fullname}</a>  chăm sóc</span>
                      }
                    </div>
                  </div>
                  <span className="timestamp" style={{ color: "#fff", fontSize: "13px" }}>{time_send}</span>
                  {/* <div className="text-right">
                    <span className="timestamp" style={{color: "#fff"}}>{time_send}</span>
                    </div> */}
                </div>
              </div>
            </div>
          </li>
        )
      } else {
        return null;
      }
    } else if (this.props.left) {
      // Kiểm tra nếu là group chat thì hiển thị tên người gửi
      const isGroupMessage = this.props.isGroupChat || this.props.Message.contact_id?.includes('_group_');
      const senderName = this.props.Message.sender_name || this.props.Message.from?.full_name || '';
      const isMediaMessage = this.props.Message.item_type == 'attachment' || this.props.Message.item_type == 'media' || this.props.Message.item_type == 'contact_recommended' || this.props.Message.item_type == 'photo_group';
      
      return (
        <li ref={(evt) => this.myref = evt} className={`last left ${this.props.left_reply ? "reply" : ""}`}>
          {
            this.props.Message.from ? <div className="avatar-box">
              <img className="avatar" src={`${this.props.Message.from.avatar}`}
                onError={(e) => {
                  e.target.src = require("../img/user.jpg")
                }}
              />
            </div> : null
          }
          <div className="box-content">
            {/* Tên người gửi cho tin ảnh (hiển thị phía trên ảnh) */}
            {isGroupMessage && senderName && isMediaMessage && (
              <div className="sender-name" style={{ 
                color: '#5a6573', 
                fontSize: '13px', 
                fontWeight: 600, 
                marginBottom: '4px'
              }}>
                {senderName}
              </div>
            )}
            <div className={`bubble ${isMediaMessage ? 'bubble-image' : ''}`}
               style={isMediaMessage ? { background: 'transparent', padding: 0, boxShadow: 'none' } : {}}>
              {reaction}
              <div className="message-content">
                {/* Tên người gửi cho tin nhắn thường (hiển thị trong bubble) */}
                {isGroupMessage && senderName && !isMediaMessage && (
                  <div className="sender-name" style={{ 
                    color: '#5a6573', 
                    fontSize: '13px', 
                    fontWeight: 600, 
                    marginBottom: '2px'
                  }}>
                    {senderName}
                  </div>
                )}
                {content}
                {
                  this.props.type == 'comment' && this.props.isSalesContact ?
                    <span className="menuTrigger">
                      <Tooltip placement="top" title={'Nhắn tin'} >
                        <a href="#" onClick={(e) => this.handleShowFormDirectNew(e)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                          </svg>
                        </a>
                      </Tooltip>
                    </span>
                    : null
                }
              </div>
            </div>
            <div className="status-mes" style={{display:'flex', justifyContent:'flex-start'}}>{time_contact.format('HH:mm')}</div>
          </div>
        </li>
      )
    } else {
      return (
        <li ref={(evt) => this.myref = evt} className={`right ${this.props.Message.status_send == 1 ? "pending" : this.props.Message.status_send == 3 ? "pending" : ""}`}>
          <div className="avatar-box"></div>
          <div className="box-content">
            <div className={`bubble ${this.props.Message.item_type == 'attachment' || this.props.Message.item_type == 'media' || this.props.Message.item_type == 'contact_recommended' || this.props.Message.item_type == 'photo_group' ? 'bubble-image' : ''}`}
              style={(this.props.Message.item_type == 'attachment' || this.props.Message.item_type == 'media' || this.props.Message.item_type == 'contact_recommended' || this.props.Message.item_type == 'photo_group') ? { background: 'transparent', padding: 0, boxShadow: 'none' } : {}}>
              {reaction}
              <div className="message-content">
                {this.props.Message.is_from_ai && (
                  <div className="ai-message-label" style={{ 
                    fontSize: '11px', 
                    color: '#8b5cf6', 
                    fontWeight: 500,
                    marginBottom: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    <i className="fas fa-robot" style={{ fontSize: '10px' }}></i>
                    Tin nhắn từ AI
                  </div>
                )}
                {content}
              </div>
            </div>
            <div className="status-mes">{time_contact.format('HH:mm')}</div>
            <div className="bottom-mes">
              {
                this.props.Message.status_send == 1 ?
                  <div className={'pending status-mes'}>
                    <span>Đang xử lý</span>
                    <i className="far fa-info-circle"></i>
                  </div> : this.props.Message.status_send == 3 ?
                    <div className="d-flex">
                      <Tooltip title={"Gửi lại"}>
                        <a href="#" className="reload d-flex align-items-center" onClick={(e) => {
                          e.preventDefault();
                          this.props.replaySendMessage({
                            id: this.props.Message._id,
                            data_send: this.props.Message.data_send
                          });
                        }}><i className="far fa-sync-alt"></i></a>
                      </Tooltip>
                      <Tooltip title={this.props.Message.error_send}>
                        <a href="#" className="reload text-danger d-flex align-items-center mr-2"><i className="far fa-info-circle"></i> Gửi lỗi</a>
                      </Tooltip>
                    </div>
                    : ''
              }
            </div>
          </div>
          {
            this.props.Message.user_read ?
              <div className="avatar-box icon-read-mes"
                title={`${this.props.Message.user_read.full_name} đã xem ${(Date.now() - this.props.Message.user_read.timestamp) < (60 * 60 * 1000 * 24) ? 'lúc ' + moment(this.props.Message.user_read.timestamp).format('HH:mm') : moment(this.props.Message.user_read.timestamp).fromNow('d') + ' trước'}`}>
                <img className="avatar" src={`${this.props.Message.user_read.avatar}`}
                  onError={(e) => {
                    e.target.src = require("../img/user.jpg")
                  }}
                />
              </div> : null
          }
        </li>
      )
    }
  }
}
